import { z } from 'zod';

import {
  EntityBaseSchema,
  EntityMetadataSchema,
  PythonicNameSchema,
  ReferenceSchema,
} from '../../base';

export const VariableReferencesSchema = z.object({
  functions: ReferenceSchema,
  delayResponses: ReferenceSchema,
  flowSteps: ReferenceSchema,
  flowNoCodeSteps: ReferenceSchema,
  flowFunctions: ReferenceSchema,
  topics: ReferenceSchema,
  behaviours: ReferenceSchema,
  greetings: ReferenceSchema,
  roles: ReferenceSchema,
  personalities: ReferenceSchema,
  sms: ReferenceSchema,
  startFunctions: ReferenceSchema,
  endFunctions: ReferenceSchema,
});

export type VariableReferences = z.infer<typeof VariableReferencesSchema>;
export type VariableReference = keyof VariableReferences;

export const VariableSchema = EntityBaseSchema.extend({
  name: PythonicNameSchema,
  references: VariableReferencesSchema,
}).merge(EntityMetadataSchema);

export type Variable = z.infer<typeof VariableSchema>;
